import {Action} from '../types/common';
import {AnyAction} from 'redux';

/* tslint:disable:ter-indent */
export const ERROR_GENERAL_ACTION : Action = {
    name: 'ERROR_GENERAL_ACTION',
    action: (apiError: any, retryAction: AnyAction = null, url = '', body = {}, method = '',
             unexpectedErrors = []) => ({
        apiError,
        retryAction,
        url,
        method,
        body,
        unexpectedErrors,
        type: ERROR_GENERAL_ACTION.name
    })
};

export const INIT_APP_ACTION : Action = {
    name: 'INIT_APP_ACTION',
    action: () => ({
        type: INIT_APP_ACTION.name
    })
};

export const CLEAN_STATE_ACTION : Action = {
    name: 'CLEAN_STATE_ACTION',
    action: () => ({
        type: CLEAN_STATE_ACTION.name
    })
};

export const CLEAR_LOADER_ACTION : Action = {
    name: 'CLEAR_LOADER_ACTION',
    action: () => ({
        type: CLEAR_LOADER_ACTION.name
    })
};
